/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = listCacheClear;
